<template>
  <div id="app">
    <AppHeader />
    <AppMain @load="loaded = $event" :loaded="loaded" />
    <AppFooter v-if="loaded" />
  </div>
</template>

<script>
export default {
data: function() {
    return {
      loaded: false
    };
  }
};
</script>

<style lang="scss">
#app {
  margin: 0 auto 60px;
  max-width: 800px;
  min-height: 101vh;
  @media screen and (max-width: 800px) {
    margin: 0 40px 60px;
  }
  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
  p {
    text-align: left;
  }
  main {
    section {
      margin: 30px 0
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue